/* src/app/shared/components/form-controls/ag-textarea/ag-textarea.component.scss */
.ag-form-control {
  height: fit-content;
}
textarea {
  resize: none;
}
/*# sourceMappingURL=ag-textarea.component.css.map */
